import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const analysisResultRestClient = new RestClient(
  atmoClient,
  "analysisresults"
);
